import { Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import {
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import ordenAgregarInventarioPdf from "../../../../Pdf/ordenAgregarInventarioPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalOrdenAgregarInventarioPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pdf: null,
    };
    this.formRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        this.consultarDatosPdf();
      }
    }
  }

  async consultarDatosPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "agregarInventario/datosPdf", 
        { ordenId: this.props.ordenId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const generador = ordenAgregarInventarioPdf(res.data);
          const pdf = pdfMake.createPdf(generador);

          this.setState(
            {
              loading: false,
              pdf: pdf,
            },
            () => {
              pdf.open({}, window.frames["OrdenInventarioPdfIframe"]);
            },
          );
        } else {
          message.error("No se encontraron datos para la orden");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al generar el documento");
        this.setState({ loading: false });
      });
  }

  descargarPdf() {
    if (this.state.pdf) {
      const nombreArchivo = `Orden_Inventario_${this.props.ordenNumero || "Documento"}.pdf`;
      this.state.pdf.download(nombreArchivo);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    return (
      <ModalItem
        title="Vista Previa Orden de Inventario"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={800} 
        footer={null} 
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 10,
          }}
        >
          <Space>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        <iframe
          title={"Orden Inventario PDF"}
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="OrdenInventarioPdfIframe"
          name="OrdenInventarioPdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalOrdenAgregarInventarioPdf);